import BarGaugeVisualization from './BarGaugeVisualization';
import './BarGaugeVisualization.scss';

export { schema, uiSchema } from '../schemas/BarGaugeVisualizationSchema';
export default BarGaugeVisualization;
